/* eslint-disable */

import { fork, all, takeEvery, put, select } from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/utils/history';
import { getLoginCode } from 'app/containers/Login/redux';
import {
  SEND_LOGIN_CODE,
  SEND_LOGIN_CODE_SUCCESS,
  SEND_LOGIN_CODE_FAIL,
} from './redux';
import Request from 'app/utils/xhrWrapper';

export function* sendCode() {
  yield takeEvery(SEND_LOGIN_CODE, function* ({ data, refrenceRoute }) : any {
    try {
      const response = yield Request.post('user/Authenticate/direct_login_step1', { account: data });
      yield put({
        type: SEND_LOGIN_CODE_SUCCESS,
        data: _.get(response, 'data'),
      });
      const loginData = yield select(state => state.getIn(['Login', 'loginCode']));
      const route = refrenceRoute || `/${history.location.pathname.split('/')[1]}`;
      yield put(getLoginCode(route, { ...loginData.toJS(), code: _.get(response, ['data', 'attributes', 'code']) }));
    } catch (error) {
      yield put({ type: SEND_LOGIN_CODE_FAIL });
    }
  });
}

export default function* () {
  yield all([
    fork(sendCode),
  ]);
}
